import { render, staticRenderFns } from "./OTLogin.vue?vue&type=template&id=75595c21&scoped=true&lang=pug"
import script from "./OTLogin.vue?vue&type=script&lang=js"
export * from "./OTLogin.vue?vue&type=script&lang=js"
import style0 from "./OTLogin.vue?vue&type=style&index=0&id=75595c21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75595c21",
  null
  
)

export default component.exports